import commonOptions from '../customOverlayOptions.options'

export default Object.assign({},commonOptions,{
    name: "OverlayMenu"
})

